import { Box, Text } from '@chakra-ui/react'

import { NOTIFICATION_ITEM_HEIGHT } from './constants'

export default function NotificationError(): JSX.Element {
  return (
    <Box
      padding="12px"
      borderRadius="8px"
      bg="bg"
      height={NOTIFICATION_ITEM_HEIGHT}
      _hover={{ bg: 'bg.muted' }}
      _active={{ bg: 'bg.emphasized' }}
      fontSize="14px"
      width="100%"
    >
      <Text variant="supporting" color="fg.muted">
        Oops! There was an error displaying this notification.
      </Text>
    </Box>
  )
}
